/** API route map: URLS.Controller.ClientGuestAttachment */
export const ClientGuestAttachment = {
      Name: 'ClientGuestAttachment/',
      GetAll: 'Client-guest-attachment',
      Add: 'add',
      DeleteAttachment: 'delete',
};
